/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory] 
*/

import React, { useRef, useCallback, useState, Fragment, useEffect } from "react";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { useHistory } from "react-router-dom";
import appRoutes from "../../routes/appRoutes";
import { CircularProgress } from "@material-ui/core";
import ICButton from "../../components/button";
import Model from "../../components/modal";
import { getBookingList, acceptBookingNo } from "../../apiRoutes";
import moment from "moment-timezone";
import Label from "../../components/label";


function createData(
  _id,
  bookingNumber,
  dateReceived,
  patientId,
  patientName,
  natureOfConsult,
  bookingDate,
  bookingTime,
  facrrmOnly
) {
  return {
    _id,
    bookingNumber,
    dateReceived,
    patientId,
    patientName,
    natureOfConsult,
    bookingDate,
    bookingTime,
    facrrmOnly
  };
}

export default function OpenAppointmentTableSticky(props) {
  // const history = useHistory();
  // const observer = useRef();
  // const [pageNo, setPageNumber] = useState(1);
  // const [nextPage, setNextPage] = useState(false);
  // const [loading, setLoading] = useState(false);
  const history = useHistory();
  const observer = useRef();
  const [pageNo, setPageNumber] = useState(1); // set current page number 
  const [nextPage, setNextPage] = useState(false); // check next page available by counting limit and current page and total count
  const [loading, setLoading] = useState(true); // api loading variable
  const [progressBar, setProgressBar] = useState(true); // progress bar
  const [limit, setLimit] = useState(10); // limit fixed
  const [skip, setSkip] = useState(0); // not using for now
  const [noMoreData, setNoMoreData] = useState(false); // no more data avialable as per API
  const [bookingModelOpen, setBookingModelOpen] = useState(false); // accept booking
  const [bookingNo, setBookingNo] = useState(null); // click button for accept booking
  const [suceessbookingModelOpen, setsuceessbookingModelOpen] = useState(false); // success booking model
  const [listIndexForRemove, setListIndexForRemove] = useState(null); // setting click index to remove from list once booking accepted

  // Column Names
  const columns = [
    {
      id: "bookingNumber",
      label: "Booking Number"
    },
    {
      id: "dateReceived",
      label: "Date Received"
    },
    {
      id: "patientId",
      label: "UIN"
    },
    {
      id: "patientName",
      label: "Patient Name"
    },
    {
      id: "natureOfConsult",
      label: "Nature of Consult"
    },
    {
      id: "bookingDate",
      label: "Booking Date"
    },
    {
      id: "bookingTime",
      label: "Booking Time (Brisbane Time)"
    },
    {
      id: "facrrmOnly",
      label: "FRACGP/ FACRRM Only"
    },
    {
      id: "action",
      label: "Action"
    }
  ];

   // Data to be appended
   const [rows, setRows] = useState([]);
   const [appendRows, setAppendRows] = useState([]);

  const goTo = (event, no) => {
    history.push({
      pathname: appRoutes.viewAppointment + "/" + no,
      state: {
        from: 1
      }
    });
  };

  const bookClickEvent = (event, bookingNo, index) => {
    event.stopPropagation();
    // console.log("Booking No: ", bookingNo);
    setBookingNo(bookingNo);
    setBookingModelOpen(true);
    setListIndexForRemove(index);
  };

  const acceptBooking = () => {
    let apiCallParam = {
      reqType: "GET",
      reqURL: acceptBookingNo + "/" + bookingNo,
      dataObj: {},
      params: {},
      headers: {},
      successCallback: res => {
        console.log("Booking Accepted");
        setBookingModelOpen(false);
      setsuceessbookingModelOpen(true);
      },
      failureCallback: err => {
        console.log("Something went wrong. Please try again ", err);
      },
      showPopUp: false
    };
    console.log("API : ", apiCallParam);
    props.makeAPICall(apiCallParam);
  };

  const closeBookingModal = () => {
    setBookingModelOpen(false);
    setBookingNo(null);
    setListIndexForRemove(null);
  };

  const closeSuccessBooking = () => {
    let appointmentList = [...rows];
    appointmentList.splice(listIndexForRemove, 1);
    setRows(appointmentList);
    setsuceessbookingModelOpen(false);
  }

  const lastElementRef = useCallback(node => {
    if (observer.current) observer.current.disconnect();
    observer.current = new IntersectionObserver(data => {
      if (data) {
        if (data[0].isIntersecting && nextPage && loading) {
          setLoading(false);
          if (loading) {
            setPageNumber(pageNo => pageNo + 1);
            let skipCalculate = limit * pageNo;
            setSkip(skipCalculate);
            getOpenAppointments(limit, skipCalculate, props.statusFilter);
          }
          setTimeout(() => {
            setLoading(true);
          }, 2000);
        }
      }
    });
    if (node) observer.current.observe(node);
  });

  const getOpenAppointments = useCallback((limitPage, skipPage, filterStatus) => {
    let updatedParam = {
      limit: limitPage,
      skip: skipPage
    };
    // if(filterStatus !== "") updatedParam['status'] = filterStatus;
    let apiCallParam = {
      reqType: "GET",
      reqURL: getBookingList,
      dataObj: {},
      params: updatedParam,
      headers: {},
      successCallback: res => {
        let openAppointmentData = [];
        res.data.data.bookings.map((value, index) => {
          // Consult Type
          let consultType = "";
          if (value.consultId && value.consultId != "") {
            consultType = value.nature_of_consult;
          } else {
            var naturofconsult = value.nature_of_consult;
            if (naturofconsult === "ConsmeticInjectableForm") {
              consultType = "Cosmetic Injectables Form";
            } else if (naturofconsult === "IVTherapyForm") {
              consultType = "IV Therapy Form";
            } else if (naturofconsult === "DentalMedicalReport") {
              consultType = "Dental Medical Report";
            } else {
              consultType = "Other";
            }
          }
          // --

          // consult duration
          let duration = value.duration;
            if (
              duration === "10" ||
              duration === "<10" ||
              duration === "589c3b332492d81210e257ea"
            ) {
              duration = "< 10 Mins";
            } else if (
              duration === "20" ||
              duration === "<20" ||
              duration === "589c3b332492d81210e257eb"
            ) {
              duration = "< 20 Mins";
            } else if (
              duration === "40" ||
              duration === "<40" ||
              duration === "589c3b332492d81210e257ef"
            ) {
              duration = "< 40 Mins";
            } else if (
              duration === ">40" ||
              duration === "592015d532b8d4787c214bb8"
            ) {
              duration = "> 40 Mins";
            }

          openAppointmentData.push(
            createData(
              value._id,
              value.bookingNumber,
              moment(value.dateCreated).tz("Australia/Brisbane").format("DD/MM/YYYY"),
              value.uin,
              value.patient_name,
              consultType,
              value.booking_date.replace(/-/g, '/'),
              moment(value.booking_time, "hh:mm A").tz("Australia/Brisbane").format("hh:mm A"),
              value.fracgpFacrrmOnly === "1" ? 'Yes' : 'No'
            )
          );
        });
        if (skipPage === 0) {
          setRows(openAppointmentData);
        } else {
          setRows(prev => prev.concat(openAppointmentData));
        }
        let currentRowCount = res.data.data.count - (pageNo * skipPage);
        if (currentRowCount > 0) {
          setNextPage(true);
        } else {
          setNextPage(false);
          setNoMoreData(true);
          setProgressBar(false);
        }
        if (!res.data.data.bookings.length) {
          setNoMoreData(true);
          setNextPage(false);
          setProgressBar(false);
        }
      },
      failureCallback: err => {
        console.log("Something went wrong. Please try again ", err);
      },
      showPopUp: false
    };
    props.makeAPICall(apiCallParam);
  });
  
  useEffect(() => {
    resetPagination();
    setRows([]);
    getOpenAppointments(limit, 0, props.statusFilter);
  }, [props.statusFilter]);

  // useEffect(() => {
  //   props.updateopenAppointmentData(rows);
  // }, [rows])

  const resetPagination = () => {
    setPageNumber(1);
    setNextPage(false);
    setLoading(true);
    setProgressBar(true);
    setSkip(0);
    setNoMoreData(false);
  };

  return (
    <Fragment>
      <Paper className="w-100">
        <TableContainer className="table-max-height primary-table-color my-open-appointment-table">
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map(column => (
                  <TableCell key={column.id} align={column.align}>
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => {
                if (rows.length === index + 1) {
                  return (
                    <TableRow
                      className="cursor-pointer"
                      ref={lastElementRef}
                      hover
                      key={row._id}
                      onClick={event => goTo(event, row._id)}
                    >
                      <TableCell>{row.bookingNumber}</TableCell>

                      <TableCell>{row.dateReceived}</TableCell>

                      <TableCell>{row.patientId}</TableCell>

                      <TableCell>{row.patientName}</TableCell>

                      <TableCell>{row.natureOfConsult}</TableCell>

                      <TableCell>{row.bookingDate}</TableCell>

                      <TableCell>{row.bookingTime}</TableCell>

                      <TableCell>{row.facrrmOnly}</TableCell>

                      <TableCell>
                        <ICButton
                          className="small"
                          type="button"
                          title="Book"
                          clickEvent={event =>
                            bookClickEvent(event, row._id, index)
                          }
                        />
                      </TableCell>
                    </TableRow>
                  );
                } else {
                  return (
                    <TableRow
                      className="cursor-pointer"
                      hover
                      key={row._id}
                      onClick={event => goTo(event, row._id)}
                    >
                      <TableCell>{row.bookingNumber}</TableCell>

                      <TableCell>{row.dateReceived}</TableCell>

                      <TableCell>{row.patientId}</TableCell>

                      <TableCell>{row.patientName}</TableCell>

                      <TableCell>{row.natureOfConsult}</TableCell>

                      <TableCell>{row.bookingDate}</TableCell>

                      <TableCell>{row.bookingTime}</TableCell>

                      <TableCell>{row.facrrmOnly}</TableCell>

                      <TableCell>
                        <ICButton
                          className="small"
                          type="button"
                          title="Book"
                          clickEvent={event =>
                            bookClickEvent(event, row._id, index)
                          }
                        />
                      </TableCell>
                    </TableRow>
                  );
                }
              })}
              {/* <TableRow className={loading ? "" : "d-none"}>
                <TableCell colSpan={7} className="text-center">
                  <CircularProgress disableShrink className="primary-loader" />
                </TableCell>
              </TableRow> */}
              <TableRow className={progressBar ? "" : "d-none"}>
                <TableCell colSpan={8} className="text-center">
                  <CircularProgress disableShrink className="primary-loader" />
                </TableCell>
              </TableRow>
              <TableRow className={noMoreData ? "" : "d-none"}>
                <TableCell
                  colSpan={8}
                  className="text-center progress-bar-center"
                >
                  <Label title="No data found" />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      {/* Confirm booking model */}
      <Model
        openModal={bookingModelOpen}
        modalBodyContent="Would you like to accept booking?"
        okayText="Yes"
        cancelText="No"
        title="Accept Booking"
        useOneButton={false}
        okayEvent={acceptBooking}
        cancelEvent={closeBookingModal}
      />
       {/* Success booking model */}
       <Model
        openModal={suceessbookingModelOpen}
        modalBodyContent="You must be available at the bokked date and time to call this patient/clinic"
        okayText="Okay"
        cancelText="Okay"
        title="Booking Accepted Successfully"
        useOneButton={true}
        okayEvent={closeSuccessBooking}
        cancelEvent={closeSuccessBooking}
      />
    </Fragment>
  );
}
